/**
 * lemon8 文章正文相关的 escape 逻辑
 */
export const escapeArticleContentChars = (content) => content.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/>/g, '&gt;').replace(/</g, '&lt;');
export const unescapeArticleContentChars = (content) => content
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<');
